import React from "react";
import footer_icon1 from "../../assets/pic/Facebook.svg";
import footer_icon2 from "../../assets/pic/instagram.svg";
import fRed from "../../assets/icons/FacebookRed.svg";
import IRed from "../../assets/icons/InstagramRed.svg";
import { LayoutForLandingPage } from "./Home";
// import footer_icon3 from "../../assets/pic/xLogo.svg";
// import footer_icon4 from "../../assets/pic/footer_icon4.svg";
// import call_icon from "../../assets/pic/callIcon.svg";
// import mail_icon from "../../assets/pic/exmailIcon.svg";
// import pin_drop_icon from "../../assets/pic/locationIcon.svg";
// import playStore from "../../assets/pic/playStore.svg";
// import appStore from "../../assets/pic/appStore.svg";
import TobreLogo from "../../assets/pic/footerwhitelogo.svg";

import { useNavigate } from "react-router-dom";
const Footer = () => {
  const [isHovered1, setIsHovered1] = React.useState(false);
  const [isHovered2, setIsHovered2] = React.useState(false);
  const redirect = useNavigate();
  return (
    <div>
      <footer className="bg-[#2F3649] py-10 text-white ">
        <LayoutForLandingPage>
          <div className="flex md:flex-row flex-col md:items-start items-center md:justify-between justify-center">
            <div className="space-y-5 text-xl md:w-1/4">
              {/* <h2 className="md:text-4xl text-2xl font-semibold">ToBre</h2> */}
              <p className="md:text-[16px] font-[400px] text-sm">
                <img
                  src={TobreLogo}
                  alt="Logo"
                  className="w-40 md:w-32 lg:w-32 xl:w-36"
                />
              </p>
              <div className="flex items-center gap-5">
                {/* <img
                src={footer_icon1}
                alt="footer_icon 1"
                width={27}
                className="cursor-pointer"
                onClick={() =>
                  window.open("https://www.facebook.com/", "_blank")
                }
              />
              <img
                src={footer_icon2}
                alt="footer_icon 2"
                width={26}
                className="cursor-pointer"
                onClick={() =>
                  window.open("https://www.instagram.com/", "_blank")
                }
              /> */}
                {/* <div className="space-y-5 text-xl md:w-fit w-full md:my-0 my-4">
              <h2 className="md:text-2xl text-xl font-semibold">Social Links</h2>
              <ul className="space-y-4 md:text-xl text-sm opacity-80">
                <li
                  className="hover:underline cursor-pointer font-[400px]"
                >
                  <img
                  src={isHovered1 ? fRed : footer_icon1}
                  alt="footer_icon 1"
                  width={27}
                  className="cursor-pointer"
                  onMouseEnter={() => setIsHovered1(true)}
                  onMouseLeave={() => setIsHovered1(false)}
                  onClick={() =>
                    window.open("https://www.facebook.com/", "_blank")
                  }
                />
                </li>
                <li
                  className="hover:underline cursor-pointer font-[400px]"
                >
                   <img
                  src={isHovered2 ? IRed : footer_icon2}
                  alt="footer_icon 2"
                  width={27}
                  className="cursor-pointer"
                  onMouseEnter={() => setIsHovered2(true)}
                  onMouseLeave={() => setIsHovered2(false)}
                  onClick={() =>
                    window.open("https://www.instagram.com/", "_blank")
                  }
                />
                </li>
              </ul>
            </div> */}
                <img
                  src={isHovered1 ? fRed : footer_icon1}
                  alt="footer_icon 1"
                  width={27}
                  className="cursor-pointer"
                  onMouseEnter={() => setIsHovered1(true)}
                  onMouseLeave={() => setIsHovered1(false)}
                  onClick={() =>
                    window.open("https://www.facebook.com/profile.php?id=61574412189548", "_blank")
                  }
                />
                <img
                  src={isHovered2 ? IRed : footer_icon2}
                  alt="footer_icon 2"
                  width={27}
                  className="cursor-pointer"
                  onMouseEnter={() => setIsHovered2(true)}
                  onMouseLeave={() => setIsHovered2(false)}
                  onClick={() =>
                    window.open("https://www.instagram.com/tobrecards/", "_blank")
                  }
                />
                {/* <img src={footer_icon3} alt="footer_icon 3" /> */}
                {/* <img src={footer_icon4} alt="footer_icon 4" /> */}
              </div>
            </div>
            <div className="space-y-5 text-xl md:w-fit w-full md:my-0 my-4">
              <h2 className="md:text-2xl text-xl font-semibold">Quick Links</h2>
              <ul className="space-y-4 md:text-xl text-sm opacity-80">
                <li
                  onClick={() => redirect("/aboutus")}
                  className="hover:underline cursor-pointer font-[400px]"
                >
                  About Us
                </li>
                <li
                  onClick={() => {
                    redirect("/browse_cards");
                  }}
                  className="hover:underline cursor-pointer font-[400px]"
                >
                  Browse Cards
                </li>
                <li
                  onClick={() => redirect("/pricing")}
                  className="hover:underline cursor-pointer font-[400px]"
                >
                  Pricing
                </li>
                <li
                  onClick={() => redirect("/blogs")}
                  className="hover:underline cursor-pointer font-[400px]"
                >
                  Blogs
                </li>
              </ul>
            </div>
            {/* <div className="space-y-5 text-xl md:w-fit w-full md:my-0 my-4">
              <h2 className="md:text-2xl text-xl font-semibold">Categories</h2>
              <ul className="space-y-4 md:text-xl text-sm opacity-80">
                <li className="hover:underline cursor-pointer font-[400px]">
                  Birthday
                </li>
                <li className="hover:underline cursor-pointer font-[400px]">
                  Weddings
                </li>
                <li className="hover:underline cursor-pointer font-[400px]">
                  Party{" "}
                </li>
                <li className="hover:underline cursor-pointer font-[400px]">
                  Trendings
                </li>
                <li className="hover:underline cursor-pointer font-[400px]">
                  Baby & Kids
                </li>
              </ul>
            </div> */}
            <div className="space-y-5 md:text-xl text-md md:w-fit w-full md:my-0 my-4">
              <h2 className="md:text-2xl text-xl font-semibold">Contact Us</h2>
              <ul className="space-y-4 opacity-80">
                <li className="flex items-center gap-x-5">
                  <span className="flex">
                    Email : {/* <img src={mail_icon} alt="mail_icon" /> */}
                  </span>
                  <a
                    href="mailto:customer@tobrecards.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    customer@tobrecards.com
                  </a>
                </li>{" "}
                {/* <li className="flex items-center gap-x-5">
                  {" "}
                  <span>
                    <img src={call_icon} alt="call_icon" />
                  </span>
                  424-947-9877
                </li>
                <li className="flex items-center gap-x-5">
                  <span>
                    <img src={pin_drop_icon} alt="pin_drop_icon" />
                  </span>
                  9256 Abigail Forges, Sao Tome and Principe
                </li> */}
              </ul>
              {/* <h2 className="md:text-2xl text-xl font-semibold">
                Download it from
              </h2>
              <div className="flex gap-2">
                <img src={playStore} alt=""></img>
                <img src={appStore} alt=""></img>
              </div> */}
            </div>
          </div>
        </LayoutForLandingPage>
      </footer>
      <div className="bg-[#191D2B] py-6 text-white">
        <LayoutForLandingPage>
          <div className="w-full mx-auto">
            <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
              <div className="text-center text-sm">
                <p>
                  &copy; Copyright {new Date().getFullYear()} All rights
                  reserved.
                </p>
              </div>
              <div className="">
                <h2 className="text-sm">
                  <button className="hover:text-primary">
                    Terms of Use
                  </button>{" "}
                  |{" "}
                  <button className="hover:text-primary">
                    Privacy Policy
                  </button>
                </h2>
              </div>
              <div>
                <h2 className="text-sm">
                  Designed By:{" "}
                  <span className="font-semibold">
                    <a
                      href="https://incipientinfo.tech/"
                      rel="noreferrer"
                      target="_blank"
                      className="hover:text-primary"
                    >
                      Incipient Infotech
                    </a>
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </LayoutForLandingPage>
      </div>
    </div>
  );
};

export default Footer;
